import React from 'react';
import { Box, Stack } from '@mui/material';

import { HeaderTooltip } from './HeaderTooltip';

export interface PageHeaderProps {
  children?: React.ReactNode;
  title: string | React.ReactElement;
  subtitle?: string | React.ReactElement | null;
  status?: React.ReactElement;
  titleTestId?: string;
}

export const PAGE_HEADER_HEIGHT = 192;

export const PageHeader = ({ title, titleTestId, subtitle, status, children }: PageHeaderProps) => {
  return (
    <Box
      alignItems='center'
      sx={{
        display: { xs: 'block', md: 'flex' },
        height: { md: PAGE_HEADER_HEIGHT },
        paddingBottom: { xs: 2, md: 'unset' },
        justifyContent: { md: 'space-between' },
      }}
    >
      <Box sx={{ flex: 1 }}>
        <HeaderTooltip
          title={title}
          textVariant='h4'
          popperTextVariant='h6'
          dataTestId={titleTestId}
        />
        {subtitle && typeof subtitle === 'string' ? <HeaderTooltip title={subtitle} /> : subtitle}
        {status}
      </Box>

      <Stack
        sx={{
          marginTop: {
            xs: 2,
            md: 'unset',
          },
          justifyContent: {
            md: 'end',
          },
        }}
        gap={1}
        direction='row'
        paddingLeft={3}
      >
        {children}
      </Stack>
    </Box>
  );
};
